module.exports = __webpack_public_path__ + "img/inquisitorail_squad_badge.676c1586.jpg";